import React, { useEffect, useState } from 'react';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

function DataExchangeBulkDeleteDialog({ mode, selectedCount, deleting, error, onClose, onConfirm }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [confirmation, setConfirmation] = useState('');
  const open = Boolean(mode);
  const deletesAll = mode === 'all';

  useEffect(() => {
    if (open) setConfirmation('');
  }, [open, mode]);

  const confirmed = !deletesAll || confirmation === 'LÖSCHEN';

  return (
    <Dialog open={open} onClose={deleting ? undefined : onClose} fullWidth maxWidth="sm" fullScreen={fullScreen}>
      <DialogTitle>{deletesAll ? 'Alle Medien löschen?' : 'Ausgewählte Medien löschen?'}</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          {error ? <Alert severity="error">{error}</Alert> : null}
          <Alert severity="warning">
            {deletesAll
              ? 'Der gesamte Bestand aus Fotos und Videos wird dauerhaft gelöscht. Dies gilt auch für Medien auf noch nicht geladenen Seiten.'
              : `${selectedCount} ${selectedCount === 1 ? 'Medium wird' : 'Medien werden'} dauerhaft gelöscht.`}
          </Alert>
          <Typography color="text.secondary">
            Gespeicherte Markierungen der betroffenen Fotos werden ebenfalls entfernt. Gastzugänge und Audit-Historie bleiben erhalten.
          </Typography>
          {deletesAll ? (
            <TextField
              autoFocus
              fullWidth
              label="Zur Bestätigung LÖSCHEN eingeben"
              value={confirmation}
              onChange={(event) => setConfirmation(event.target.value)}
              disabled={deleting}
              autoComplete="off"
            />
          ) : null}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} disabled={deleting}>Abbrechen</Button>
        <Button
          color="error"
          variant="contained"
          startIcon={deleting ? <CircularProgress size={18} color="inherit" /> : <DeleteOutlineIcon />}
          onClick={onConfirm}
          disabled={deleting || !confirmed || (!deletesAll && selectedCount === 0)}
        >
          {deletesAll ? 'Alle Medien endgültig löschen' : `${selectedCount} ${selectedCount === 1 ? 'Medium' : 'Medien'} löschen`}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DataExchangeBulkDeleteDialog;